import { collection, getDocs, query, where } from 'firebase/firestore';

import { SectionTypeConfig } from '@superfunnel/types/section-type-config';

import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const sectionTypesColRef = () => {
  return collection(db, 'sectionTypes').withConverter(
    emptyConverter<SectionTypeConfig>(),
  );
};

export const getAccountSectionTypes = async (accountId: string) => {
  return getDocs(
    query(sectionTypesColRef(), where('accountId', 'in', [accountId, ''])),
  );
};
